import { useEffect, useState } from 'react';

import { formatLifeCountdown } from '../lib/format-life-countdown';
import { useGameResources } from './resources';

export const useLifeCountdown = (login?: string) => {
  const resources = useGameResources(login);
  const [now, setNow] = useState(() => Date.now());
  const nextLifeAt = resources.nextLifeAt;

  useEffect(() => {
    if (nextLifeAt === null) return;
    const tick = () => {
      resources.recover();
      setNow(Date.now());
    };
    tick();
    const interval = window.setInterval(tick, 1000);
    return () => window.clearInterval(interval);
  }, [resources, nextLifeAt]);

  return nextLifeAt !== null && Number.isFinite(nextLifeAt) ? formatLifeCountdown(nextLifeAt, now) : null;
};
